<div class="">
  <div class="container-fluid content-bg">
    <div class="card card-login mx-auto mt-5">
      <div class="card-header">Forgot Password
        <button type="button" class="close" data-dismiss="modal" (click)="loginClose()" >&times;</button>
      </div>
      <div class="card-body">
        <form id="loginform">
            <div class="form-group" >
                <label for="mobile">Country Code</label>
                <select class="form-control" [(ngModel)]="country" name="country" ngModel #cref="ngModel" [disabled]="code_readonly">
                    <option [ngValue]="undefined"hidden>Code</option>
                    <option *ngFor="let suit of codeDropdown" >{{suit}}</option>
                </select>
                <div *ngIf="cref.errors &&(cref.touched || cref.dirty)"
                    class="alert alert-danger">
                    <div [hidden]="!cref.errors?.required">
                        Country Code Required
                    </div>
                </div>
            </div>
          <div class="form-group">
            <label for="email">Mobile</label>
            <input type="number" class="form-control" id="mobile"
              name="mobile" ngModel #emailref="ngModel" [(ngModel)]="mobile_num" [readonly]="mobile_readonly" >
            <!-- <div *ngIf="emailref.errors &&(emailref.touched || emailref.dirty)" class="alert alert-danger">
              <div [hidden]="!emailref.errors?.pattern">
                Invalid pattern
              </div>
            </div> -->
          </div> 
          <div *ngIf="!this.click">
            <input type="submit" [disabled]="click" (click)="submitForgot()" class="btn btn-primary btn-block"
            value="Submit" />
          </div>
        </form>

        <div class="" *ngIf="this.click">
          <app-forgot (resend)="submitForgot($event)"></app-forgot>
        </div>
      </div>
    </div>
  </div>
</div>